import React, { useState } from 'react'
import ProjectRecommendRegister from '../components/ProjectRecommendRegister/ProjectRecommendRegister'

const ProjectRecommendRegisterPage = () => {
  return (
    <>
      <ProjectRecommendRegister />
    </>
  )
}

export default ProjectRecommendRegisterPage
